<template>
  <div class="dropdown d-inline ">
    <soft-button v-show="abonadoSelected == ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class="dropdown-toggle ms-2"
      data-bs-toggle="dropdown" aria-expanded="true">{{ $t('key_filterRefund_title') }}</soft-button>
    <soft-button v-show="abonadoSelected != ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class='dropdown-toggle ms-2 active-filter' 
      data-bs-toggle="dropdown" aria-expanded="false">{{ $t('key_filterRefund_title') }}</soft-button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="navbarDropdownMenuLink2">
      <li>
        <button class="dropdown-item border-radius-md text-warning" :class="[abonadoSelected=='noPaid'? 'active':'']" type="button" @click="handleClick('noPaid')">{{ $t('key_orderBackList_orderBackRefundPending') }}</button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-success" :class="[abonadoSelected=='paid'? 'active':'']" type="button" @click="handleClick('paid')">{{ $t('key_orderBackList_orderBackRefunded') }}</button>
      </li>
      <li>
        <hr class="horizontal my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-danger" type="button" @click="handleClick('')">{{ $t('key_filterRefund_clearFilters') }}</button>
      </li>
    </ul>  
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
 

export default {
  name:"OrdersBackFilterAbonado",
  components: {
    SoftButton,  
  },
  props: {
    filterabonadoSelected: {
      type: String,
      default: () => '',
    },
  },
  emits: ['filter-change'],
  data() {
    return {
      optionsStatus: [],
    abonadoSelected:""
    }
  },
  computed: {
    listFilters() {
      return this.$store.state.ordersBackList.listFilters;
    },
  },
  watch: {
    filterabonadoSelected() {
      this.abonadoSelected = this.filterabonadoSelected
    }
  },
  mounted() {
    this.setUpFilters()
  },
  methods: {
    handleClick(status) {
      this.abonadoSelected=status
      this.$emit('filter-change',status)
    },
    setUpFilters() {
      if (Object.keys(this.listFilters).length > 0) {

        const { filters } = this.listFilters

        if (filters['paid'] && filters['paid'] == true) {
          this.abonadoSelected = 'paid'
        }

        if (filters['noPaid'] && filters['noPaid'] == true) {
          this.abonadoSelected = 'noPaid'
        }
      }
    },
  },
}
</script>

<style scoped>
.active{
  background-color: rgb(234, 244, 247) !important;
}

.active-filter {
  color: #fff;
  background-color: #42695c;
  border-color: #42695c;
}
</style>